import { Injectable } from '@angular/core';
// CORREGIDO: Se añaden 'Headers' y 'RequestOptions' a la importación de @angular/http
import { Http, URLSearchParams} from '@angular/http';

import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';
import { ValidatorService } from './tools/validator.service';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

// Importación del entorno global
import { environment } from '../../environments/environment';

// Interfaz estricta para los filtros del Dashboard
export interface DashboardFilters {
    'start-date'?: string;
    'end-date'?: string;
    idSucursales?: number | string;
}

@Injectable()
export class DashboardService {

    // Endpoint centralizado del recurso
    private service_url: string;

    constructor(
        private http: Http,
        private constantsService: ConstantsService,
        private authService: AutenticacionService,
        private validatorService: ValidatorService,
    ) {
        this.service_url = this.constantsService.apiURL + '/dashboard';
    }

    /**
     * Obtiene de forma consolidada las métricas generales (KPIs) y las 
     * tendencias mensuales para las gráficas en una sola petición HTTP.
     * @param filters Objeto con rango de fechas y sucursal opcional.
     * @returns Observable con la respuesta mapeada para el componente.
     */
    public getResumenGeneral(filters: DashboardFilters): Observable<any> {
        const params = new URLSearchParams();

        // Construcción segura de Query Parameters
        if (filters['start-date']) {
            params.set('start-date', filters['start-date']);
        }

        if (filters['end-date']) {
            params.set('end-date', filters['end-date']);
        }

        if (filters['idSucursales']) {
            params.set('idSucursales', filters['idSucursales'].toString());
        }

        // 1. Recuperamos el objeto RequestOptions con los tokens integrados
        let myoptions = this.authService.getAuthHeaders();
        
        // 2. CORRECCIÓN: Para @angular/http nativo se usa 'search', no 'params'
        myoptions.search = params;

        // 3. CORRECCIÓN: Volvemos a concatenar '/resumen' para evitar el 404 de Lumen
        return this.http.get(`${this.service_url}/resumen`, myoptions)
            .map((res: any) => res.json())
            .catch(this.handleError);
    }

    /**
     * Manejador de errores reactivo a nivel de servicio.
     */
    private handleError(error: any): Observable<any> {
    console.error(`[DashboardService Error]:`, error);
    
    // Esta es la única forma válida para RxJS 5 / @angular/http
    return Observable.throw(error || 'Error en el servidor');
}
}


// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.ts